var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-header',{staticClass:"pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success"}),_c('b-container',{staticClass:"mt--7",attrs:{"fluid":""}},[_c('div',{staticClass:"mt-5"}),_c('job-group-history-table')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }